export default "__VITE_ASSET__UXhfofzk__"